import { createSelector } from 'reselect';
import getStoreProductDetails from '../../utils/getStoreProductDetails';

// I know
export default createSelector(
  state => state,
  state => getStoreProductDetails(state),
);
